// Stored (standalone) reminder commands — reminders/{id}, private to the person. Pure.
import { REMINDER_STYLES, SNOOZE_DEFAULT, markHandled } from '../reminders.js';
import { del, set, update } from './writes.js';

const now = (ctx) => (typeof ctx.now === 'function' ? ctx.now() : ctx.now ?? Date.now());
const need = (ctx, id) => { const r = (ctx.reminders || []).find((x) => x.id === id); if (!r) throw new Error(`no reminder ${id}`); return r; };

export function makeReminderDoc(input, at, newId) {
  const title = String(input.title || '').trim();
  if (!title) throw new Error('title required');
  if (!Number.isFinite(input.at)) throw new Error('at (ms) required');
  return {
    id: input.id || newId(), title, body: input.body || null, at: input.at,
    ...(input.repeat ? { repeat: input.repeat } : {}),
    style: REMINDER_STYLES.includes(input.style) ? input.style : 'banner',
    link: input.link && input.link.type && input.link.id ? { type: input.link.type, id: input.link.id } : null,
    actions: Array.isArray(input.actions) ? input.actions : null,
    snooze: Array.isArray(input.snooze) && input.snooze.length ? input.snooze : SNOOZE_DEFAULT,
    nag: input.nag || null,
    status: 'scheduled', firedAt: null, handledAt: null, handledAction: null, snoozedUntil: null,
    source: input.source || 'manual', createdAt: at, updatedAt: at,
  };
}

export function addReminder(ctx, input) {
  const reminder = makeReminderDoc(input, now(ctx), ctx.newId);
  return { writes: [set(`reminders/${reminder.id}`, reminder)], reminder };
}

const R_EDITABLE = new Set(['title', 'body', 'at', 'repeat', 'style', 'link', 'actions', 'snooze', 'nag', 'status']);

export function updateReminder(ctx, { id, ...patch }) {
  need(ctx, id);
  const data = {};
  for (const [k, v] of Object.entries(patch)) if (R_EDITABLE.has(k) && v !== undefined) data[k] = v;
  if (!Object.keys(data).length) throw new Error('nothing to update');
  if ('at' in data) Object.assign(data, { status: 'scheduled', snoozedUntil: null, firedAt: null, handledAt: null, handledAction: null });
  data.updatedAt = now(ctx);
  return { writes: [update(`reminders/${id}`, data)], patch: data };
}

/** done | snooze | missed | cancel | fired | <any action name> */
export function handleReminder(ctx, { id, action, minutes }) {
  const r = need(ctx, id);
  const data = markHandled(r, action, { now: now(ctx), minutes });
  return { writes: [update(`reminders/${id}`, data)], patch: data };
}

export function deleteReminder(ctx, { id }) {
  need(ctx, id);
  return { writes: [del(`reminders/${id}`)] };
}
